import React from "react";

export const isArticleEmpty = (article) => {
    if (!article || typeof article !== "object") return true;
    return Object.entries(article)
        .filter(([key]) => key !== "uuid")
        .every(([_, val]) =>
            Array.isArray(val) ? val.length === 0 : val === null || val === ""
        );
};

export const ArticleDescriptionSentences = ({ text = "Enter Article Description", space = "0.8em" }) => (
    <>
        {text
            .split(".")
            .filter(sentence => sentence.trim() !== "")
            .map((sentence, idx, arr) => (
                <React.Fragment key={idx}>
                    {sentence.trim()}
                    {idx < arr.length - 1 && "."}
                    {idx < arr.length - 1 && (
                        <span style={{ display: "block", height: space }} />
                    )}
                </React.Fragment>
            ))
        }
    </>
);
